module.exports = __webpack_public_path__ + "img/navigate-to-home.eab18275.svg";